import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {Body, H1, H6} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"

import FormattedMessage, {useIntl} from "@irati/utils/lang"
import {BILLING_TABS} from "../../../containers/Billing"
import {LinearGradiantCard} from "./styled"

interface Props {
  image: string
  title: string
  text: Component
}

const Persona: FC<Props> = ({image, title, text}) => {
  const theme = useTheme()
  const {formatMessage} = useIntl()

  return (
    <LinearGradiantCard c1={theme.colors.tertiary.i_400} c2={theme.colors.primary1}>
      <Flex alignItems="center" direction="column" gap={1}>
        <H6 color={theme.colors.greys.white}>
          <FormattedMessage id="admin.components.yourPerkboxStory.persona.title" />
        </H6>
        <img src={formatMessage({id: image})} width={150} height={150} />
        <H1 color={theme.colors.greys.white}>
          <FormattedMessage id={title} />
        </H1>
        <Body small color={theme.colors.greys.white}>
          {text}
        </Body>
        <ButtonRouterLink inverted to={`/billing/${BILLING_TABS.NEW_PLAN}`}>
          <FormattedMessage id="admin.components.yourPerkboxStory.persona.btn" />
        </ButtonRouterLink>
      </Flex>
    </LinearGradiantCard>
  )
}

export default Persona
